<template>
  <div class="print-page">
    <div v-for="(page, idx) in survey.pages" :key="idx">
      <div v-for="(ques, i) in page.questions" :key="i" class="question-viewer">
        <div v-if="ques.type == 'radio'">
          <radio :ques="ques" :isEditing="false"></radio>
        </div>
        <div v-if="ques.type == 'checkbox'">
          <checkbox :ques="ques" :isEditing="false"></checkbox>
        </div>
        <div v-if="ques.type == 'textarea'">
          <text-area :ques="ques" :isEditing="false"></text-area>
        </div>
        <div v-if="ques.type == 'star'">
          <star :ques="ques" :isEditing="false"></star>
        </div>
        <div v-if="ques.type == 'matrixRadio'">
          <matrix-radio :isEditing="false" :ques="ques"></matrix-radio>
        </div>
        <div v-if="ques.type == 'matrixCheckbox'">
          <matrix-checkbox :isEditing="false" :ques="ques"></matrix-checkbox>
        </div>
        <div v-if="ques.type == 'matrixStar'">
          <matrix-star :isEditing="false" :ques="ques"></matrix-star>
        </div>
        <div v-if="ques.type == 'select'">
          <wqselect :ques="ques" :isEditing="false"></wqselect>
        </div>
        <div v-if="ques.type == 'sort'">
          <sort :ques="ques" :isEditing="false"></sort>
        </div>
        <div v-if="ques.type == 'description'">
          <description :ques="ques" :isEditing="false"></description>
        </div>
        <div v-if="ques.type == 'upload'">
          <upload :ques="ques" :isEditing="false"></upload>
        </div>
        <div v-if="ques.type == 'chainedSelects'">
          <chained-selects :ques="ques" :isEditing="false"></chained-selects>
        </div>
        <div v-if="ques.type == 'textMultiple'">
          <text-multiple :ques="ques" :isEditing="false"></text-multiple>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../utils/http";
import { MSG } from '../utils/utils'
import {
  radio,
  checkbox,
  textArea,
  star,
  matrixRadio,
  matrixCheckbox,
  matrixStar,
  wqselect,
  sort,
  description,
  upload,
  chainedSelects,
  textMultiple
} from "../components/ques-widget.js";

export default {
  name: "Print",
  data() {
    return {
      interface: {
        getSurvey: `/survey/get`
      },
      activeTab: "phone",
      survey: {
        pages: []
      }
    };
  },
  components: {
    radio,
    wqselect,
    sort,
    description,
    upload,
    checkbox,
    textArea,
    star,
    matrixRadio,
    matrixCheckbox,
    matrixStar,
    chainedSelects,
    textMultiple
  },
  mounted() {
    this.getSurvey();
  },
  methods: {
    getSurvey() {
      http
        .get(this.interface.getSurvey, {
          surveyId: this.$route.query.id
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.survey = data;
            setTimeout(function() {
              window.print();
            });
          } else {
            MSG.error(message)
          }
        })
    }
  }
};
</script>

<style lang="scss">
.print-page {
  background-color: #fff;
}
.question-viewer {
  padding: 20px 100px;
  margin-bottom: 25px;
  position: relative;
  min-height: 160px;
  .el-radio {
    vertical-align: top;
    .el-radio__label {
      width: 90%;
      display: inline-block;
      white-space: pre-line;
      word-wrap: break-word;
      vertical-align: text-top;
    }
  }
  .el-checkbox {
    .el-checkbox__label {
      width: 90%;
      white-space: pre-line;
      vertical-align: top;
    }
  }
  .el-radio-group:not(.starRadios) {
    width: 100%;
  }
  .starRadios {
    overflow: hidden;
  }
  .starText {
    margin: 0 15px;
    float: left;
    line-height: 24px;
  }
  .starRadio {
    float: left;
    line-height: 24px;
  }
  .el-checkbox,
  .el-radio:not(.starRadio) {
    margin-bottom: 20px;
    &.row-1 {
      width: 100%;
    }
    &.row-2 {
      width: 50%;
    }
    &.row-3 {
      width: 33.3%;
    }
    &.row-4 {
      width: 25%;
    }
    &.row-5 {
      width: 20%;
    }
    &.row-6 {
      width: 16.6%;
    }
    &.row-7 {
      width: 14.2%;
    }
    &.row-8 {
      width: 12.5%;
    }
    &.row-9 {
      width: 11.1%;
    }
    &.row-10 {
      width: 10%;
      .el-radio__label {
        padding-left: 5px;
      }
    }
  }
  .el-checkbox + .el-checkbox,
  .el-radio:not(.starRadio) + .el-radio:not(.starRadio) {
    margin-left: 0;
  }
  &:hover {
    background-color: #f0f0f0;
    .ques-cover {
      .cover-tools {
        right: 0;
      }
    }
  }
  .ques-title {
    line-height: 30px;
  }
  .required-icon {
    color: #ff552e;
    font-size: 20px;
    display: inline-block;
    height: 24px;
    vertical-align: middle;
    margin-left: 5px;
  }
  .ques-desc {
    margin-bottom: 20px;
    color: #999;
  }
  .ques-cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    cursor: move;
    .cover-tools {
      width: 80px;
      position: absolute;
      right: -80px;
      top: 50%;
      margin-top: -80px;
      border-left: 1px solid #e1e6eb;
      transition: all 0.2s;
      li {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #888;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
          background-color: #ff552e;
          color: #fff;
        }
      }
    }
  }
  .gotoDisp {
    color: #aaa;
    margin-left: 10px;
    font-size: 12px;
  }
  .matrix-disp {
    text-align: center;
    .matrix-title {
      display: flex;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 120px;
    }
    .matrix-option {
      flex: 1;
      word-break: break-all;
    }
    .matrix-content {
      height: 40px;
      line-height: 40px;
    }
    .matrix-subtitle {
      width: 120px;
      text-align: left;
      word-break: break-all;
      float: left;
    }
  }
  .inputs {
    position: relative;
    .matrix-group {
      position: relative;
      margin-left: 175px;
    }
    .table-scoll {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      zoom: 1;
    }
    .option_title {
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      min-width: 80px;
    }
    .option_choose {
      min-width: 82px;
      text-align: center;
      vertical-align: middle;
      padding-top: 14px;
    }
    .table_freezed {
      margin-left: -175px;
      .el-radio__label,
      .el-checkbox__label {
        display: none;
      }
    }
    .sub_title {
      // width: 25%;
      min-width: 175px;
      width: 175px;
      padding-top: 14px;
      padding-bottom: 14px;
      .subtitle_text {
        // padding-left: 10px;
        line-height: 20px;
        overflow: hidden;
      }
    }
    .matrix_group_mirror {
      position: absolute;
      top: 0px;
      width: 175px;
      min-width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/print.vue